import { metadata } from 'aurelia-framework';
import { WidgetPropertyType } from './widget-property-type';
import { IPropertyMetadata } from './i-property-metadata';

export const PROPERTIES_METADATA_KEY = 'dynamik:widget-properties';

export function property(group?: string, label?: string, type?: WidgetPropertyType, listValues?: IPropertyMetadata['listValues']) {
  return function propertyDecorator(target: any, propertyKey: string) {
    const labelParts = propertyKey.replace(/([A-Z])/g, ' $1').toLowerCase().split(' ');
    if (group === undefined) {
      group = `${labelParts[0][0].toUpperCase()}${labelParts[0].slice(1)}`;
    }

    if (label === undefined && group) {
      // split and capitalize first word of propertyKey
      if (labelParts[0] === group.toLowerCase() && labelParts.length > 1) {
        labelParts.shift();
      }
      labelParts[0] = `${labelParts[0][0].toUpperCase()}${labelParts[0].slice(1)}`;
      label = labelParts.join(' ');
    }
    const designType = metadata.getOwn('design:type', target, propertyKey);
    if (type === undefined) {
      if (propertyKey.toLowerCase().replace('colour', 'color').includes('color') && designType === String) {
        type = WidgetPropertyType.Colour;
      }
      else if (propertyKey.toLowerCase().includes('font') && designType === String) {
        type = WidgetPropertyType.Font;
      }
      else if (propertyKey.toLowerCase().includes('theme') && designType === String) {
        type = WidgetPropertyType.Theme;
      }
      else if (designType === Number) {
        type = WidgetPropertyType.Number;
      } else if (designType === Boolean) {
        type = WidgetPropertyType.Boolean;
      } else {
        type = WidgetPropertyType.Text;
      }
    }
    let props = metadata.getOrCreateOwn(PROPERTIES_METADATA_KEY, function () { return []; }, target.constructor) as IPropertyMetadata[];
    props.push({ group, name: propertyKey, label, type, listValues });
  };
}
